import React from 'react';

/**
 * 显示时间
 */
export default class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { secondsElapsed: 0 };
  }

  componentDidMount() {
    this.interval = setInterval(
      this.setState((prevState) => ({
        secondsElapsed: prevState.secondsElapsed + 1
      })), 
      1000
    )
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render = () => (
    <span>
      计时: {this.state.secondsElapsed}秒
    </span>
  )
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Timer.js